import React, { useState } from 'react';
import Tab from '../../components/elements/Tab/Tab';
import AktivasiPencatatanManual from './AktivasiPencatatanManual';
import SettingPencatatanManual from './SettingPencatatanManual';
import styles from './styles.scoped.css';

export default function PencatatanManual (){
  const [tabItem, setTabItem] = useState('submission');
  const tabList = [
    { label: 'Daftar Pengajuan', value: 'submission', info: '' },
    { label: 'Pengaturan Penyetujuan Otomatis', value: 'setting' },
  ];
  const handleChangeTab = (val) => {
    setTabItem(val);
  };
  return(
    <div className={styles.root}>
      <Tab
        data={tabList}
        defaultValue={tabItem}
        onChange={handleChangeTab} />
      {tabItem === 'submission' ?
        <AktivasiPencatatanManual />
        :
        <SettingPencatatanManual />
      }
    </div>
  );
}
